var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '@utils/apiClient';
export const businessService = {
    getAll() {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get('/businesses');
        });
    },
    getById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get(`/businesses/${id}`);
        });
    },
    create(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.post('/businesses', data);
        });
    },
    update(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.put(`/businesses/${id}`, data);
        });
    },
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.delete(`/businesses/${id}`);
        });
    },
};
